import type { ExerciseCategory } from "@/lib/api/api-client";

export const CATEGORY_META: Record<
  ExerciseCategory,
  { label: string; color: string; hue: number }
> = {
  fondations: { label: "Fondations", color: "#f97316", hue: 25 },
  rythme: { label: "Rythme", color: "#fbbf24", hue: 45 },
  gammes: { label: "Gammes", color: "#4ade80", hue: 140 },
  arpeges: { label: "Arpèges", color: "#60a5fa", hue: 215 },
  accords: { label: "Accords", color: "#a78bfa", hue: 260 },
  independance: { label: "Indépendance", color: "#2dd4bf", hue: 170 },
  lecture: { label: "Lecture & motifs", color: "#f472b6", hue: 330 },
  musicalite: { label: "Musicalité", color: "#e879f9", hue: 290 },
};

export function CategoryIcon({
  category,
  size = 20,
}: {
  category: string;
  size?: number;
}) {
  const s = size;

  switch (category) {
    case "fondations":
      return (
        <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
          <rect x="4" y="12" width="12" height="4" rx="1" />
          <rect x="6" y="7" width="8" height="5" rx="1" />
          <path d="M10 3v4" />
          <circle cx="10" cy="3" r="1" />
        </svg>
      );
    case "rythme":
      return (
        <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="7" cy="14" r="2.5" />
          <circle cx="15" cy="12" r="2.5" />
          <path d="M9.5 14V5l6-2v9" />
        </svg>
      );
    case "gammes":
      return (
        <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
          <path d="M3 15l2-3 2 1 2-4 2 2 2-5 2 3 2-2" />
        </svg>
      );
    case "arpeges":
      return (
        <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 16l3-4 3 2 3-6 3-4" />
          <circle cx="4" cy="16" r="1" />
          <circle cx="7" cy="12" r="1" />
          <circle cx="10" cy="14" r="1" />
          <circle cx="13" cy="8" r="1" />
          <circle cx="16" cy="4" r="1" />
        </svg>
      );
    case "accords":
      return (
        <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
          <rect x="4" y="6" width="3" height="10" rx="0.5" />
          <rect x="8.5" y="4" width="3" height="12" rx="0.5" />
          <rect x="13" y="7" width="3" height="9" rx="0.5" />
        </svg>
      );
    case "independance":
      return (
        <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 14l4-8 4 8 4-8" />
        </svg>
      );
    case "lecture":
      return (
        <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
          <path d="M4 5h12M4 8h12M4 11h12M4 14h12M4 17h12" />
          <circle cx="7" cy="8" r="1.5" fill="currentColor" />
          <circle cx="13" cy="14" r="1.5" fill="currentColor" />
        </svg>
      );
    case "musicalite":
      return (
        <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round">
          <path d="M5 10c0-3 2-6 5-6s5 3 5 6" />
          <path d="M7 10c0-1.5 1-3 3-3s3 1.5 3 3" />
          <path d="M10 10v6" />
          <circle cx="10" cy="10" r="1" fill="currentColor" />
        </svg>
      );
    default:
      return (
        <svg width={s} height={s} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round">
          <circle cx="10" cy="10" r="6" />
        </svg>
      );
  }
}
